import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { EmployeeService } from '../../services/employee.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PartnerService } from '../../services/partner.service';


@Component({
  selector: 'app-editsubscription',
  templateUrl: './editsubscription.component.html',
  styleUrls: ['./editsubscription.component.scss']
})
export class EditsubscriptionComponent implements OnInit {
  public isPageEditable: boolean = true;
  statusMessage: string = "Loading data please wait...";
  IsFormEdit: boolean = false;
  public isSlide: boolean = false;
  productForm: FormGroup;
  sideBarToggle : any;
  subscriptionid: any = '';
  subname: any = '';
  programfor: any = '';
  credit: any = '';
  plancost: any = '';
  creditapply: any = '';
  consultationcount: any = '';
  agerestriction: any = '';
  programtype: any = '';
  member: any = '';
  planyears: any = '';
  partnerid: any = '';
  programFamily = false;
  programIndividual = false;
  partnerTypeList = [
    "Corporate",
    "Subscription"
  ]
  partnerType = '';
  partners = [];
  partnerName = '';
  allPartnersList = [];
  selectedPartnerId : any;

  showPartners : boolean = false;
  ageRestriction : boolean = true;

  members = ['0',
    'M',
    'M+1',
    'M+2',
    'M+3',
    '2 Adult + U kids'
  ];

  creditApplyIndividual = [
    "Individual",
    "N/A"
  ]
  creditApplyOriginal = [
    "Individual",
    "N/A"
  ]
  creditApplyFamily = [
    "Family",
    "N/A"
  ]

  MembersDefaultList = [
    { key : 'M' , value:  'M' }
  ]

  ageGroup1 = [
    { key : '30' , value : 30},
    { key : '40',  value : 40},
    { key : '50', value : 50},
    { key : 'N/A', value : 'N/A'}
  ]
  ageGroup2 = [
    { key : '40',  value : 40},
    { key : '50', value : 50},
    { key : 'N/A', value : 'N/A'}
  ]
  ageGroupTemp = [
    { key : '40',  value : 40},
    { key : '50', value : 50},
    { key : 'N/A', value : 'N/A'}
  ]



  constructor(private _partnerService: PartnerService,public route: ActivatedRoute, private router: Router,private _employeeService: EmployeeService,private fb: FormBuilder) {
    this.productForm = fb.group({
      planYears: ['', [Validators.required]],
      PlanCost: ['', [Validators.required]],
      Credit: ['', [Validators.required]],
      creditapply: [],
      programtype: [],
      memberdata: [],
      Consultationcount: [],
      subscriptionName: [],
      programfor: [],
      agelimit1: [],
      agelimit2: [],
      partnerId: [],
      partnerType: []
    })
    this.getPartnerList();
    
  }

  ngOnInit() {
    this.subscriptionid= this.route.snapshot.paramMap.get('subscriptionid');
    this.subname = this.route.snapshot.paramMap.get('subname');
    this.programfor = this.route.snapshot.paramMap.get('programfor');
    this.credit = this.route.snapshot.paramMap.get('credit');
    this.plancost = this.route.snapshot.paramMap.get('plancost');
    this.creditapply = this.route.snapshot.paramMap.get('creditapply');
    this.consultationcount = parseInt(this.route.snapshot.paramMap.get('consultationcount'));
    console.log('test ', this.route.snapshot.paramMap.get('agerestriction'));
    if(this.route.snapshot.paramMap.get('agerestriction') == 'N/A'){
      this.agerestriction = this.route.snapshot.paramMap.get('agerestriction');
    }
    else{
      this.agerestriction = parseInt(this.route.snapshot.paramMap.get('agerestriction'));
    }
    this.programtype = this.route.snapshot.paramMap.get('programtype');
    console.log('member ', this.route.snapshot.paramMap.get('members'));
    this.member = this.route.snapshot.paramMap.get('members');
    this.planyears = this.route.snapshot.paramMap.get('planyears');
    this.partnerid = this.route.snapshot.paramMap.get('partnerid');
    this.getPartnerList();
   
    this.productForm.controls['subscriptionName'].setValue(this.subname);
    this.productForm.controls['Consultationcount'].setValue(this.consultationcount);
    this.productForm.controls['planYears'].setValue(this.planyears);
    this.productForm.controls['PlanCost'].setValue(this.plancost);
    this.productForm.controls['Credit'].setValue(this.credit);
    this.productForm.get('creditapply').setValue(this.creditapply);
    this.productForm.get('programtype').setValue(this.programtype);
    this.productForm.get('memberdata').setValue(this.member);
    this.productForm.get('planYears').setValue(this.planyears);
    this.productForm.get('programfor').setValue(this.programfor);
    this.productForm.get('agelimit1').setValue(this.agerestriction);
    this.productForm.get('agelimit2').setValue(parseInt(this.agerestriction+10));
    
    
  }

  updateSubscription(record) {
    console.log('updateSubscription ', record);
     let subscriptionData = {
      "token": '',
      "subscriptionid": this.subscriptionid,
       "subname": record.controls.subscriptionName.value,
       "programfor":this.programfor,
       "credit": record.controls.Credit.value,
       "plancost":record.controls.PlanCost.value,
       "creditapply":record.controls.creditapply.value,
       "consultationcount":parseInt(record.controls.Consultationcount.value),
       "agerestriction":parseInt(record.controls.agelimit1.value),
       "programtype":record.controls.programtype.value,
       "members":record.controls.memberdata.value,
       "planyears":parseInt(record.controls.planYears.value),
       "partnerid":record.controls.partnerId.value
        }
     console.log('subscriptionData save', subscriptionData);
     this._employeeService.updateSubscriptionDetails(subscriptionData).subscribe((data)=>{
       console.log('success data ', data);
       if(data.returnCode == 0){
         alert('Subscription Saved Succcessfully');
         this.productForm.reset();
         this.viewSubscription();
       }
     })
  }


  //reset method.
  reset(){
    this.productForm.reset();
  }

  viewSubscription(){
    let pageValue = {
      "viewSubscription": 'true'
    }
    this.router.navigate(['/subscription', pageValue]);
  }

  // selectPrimary(data: any){
  //   this.programfor = data;
  //   console.log('this.programfor ', this.programfor);
  // }

  selectProgramType(id:any){
    console.log('id ', id);
    if(id == 'Corporate'){
      this.programtype = id;
      this.showPartners = true;
    }
    else if(id == 'Anyone'){
      this.programtype = id;
      this.showPartners = false;
      this.selectedPartnerId = null;
    }
  }


  selectPrimary(data: any){
    console.log('data ', data);
    if(data == "family"){
      this.ageRestriction = false;
      this.programfor = data;
      this.creditApplyOriginal = this.creditApplyFamily;
      this.MembersDefaultList = [];
      this.MembersDefaultList = [
        // { key : '0' , value:  '0' },
        { key : 'M' , value:  'M' },
        { key : 'M+1' , value : 'M+1'},
        { key : 'M+2' , value :  'M+2'},
        { key : 'M+3' , value : 'M+3'},
        { key : '(2 Adults + U Kids)' , value : '2 Adults + U Kids'}
      ]

    }
    else if(data == "Individual"){
      this.ageRestriction = true;
      this.programfor = data;
      this.creditApplyOriginal = this.creditApplyIndividual;
      this.MembersDefaultList = [];
      this.MembersDefaultList = [
        { key : 'M' , value:  'M' }
      ]
    }
  }

  getPartnerList() {
    let tempPartnersList = [];
    this._partnerService.getPartners()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.partners = employeeData.response.partnerList;
            this.allPartnersList = this.partners;
           // console.log('this.partners ', this.partners);
           // console.log('this.allPartnersList ', this.allPartnersList);
            for(let index = 0; index< this.partners.length;index++){
              if(this.partners[index].partnerType.toLowerCase() == 'Subscription'.toLowerCase()){
                tempPartnersList.push(this.partners[index]);
              }
            }
            this.partners = tempPartnersList;
            this.getPartnerTypeById(this.partnerid);
          }
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }


  selectPartner(data: any){
    let tempPartnersList = [];
    for(let index = 0;index < this.allPartnersList.length;index++){
      if(this.allPartnersList[index].partnerType.toLowerCase() == data.toLowerCase()){
        tempPartnersList.push(this.allPartnersList[index]);
      }
    }
    this.partners = tempPartnersList;
  }

  selectPartnerId(data: any){
    console.log('data ', data);
    this.selectedPartnerId = data;
  }

  getPartnerTypeById(id: any){
    console.log('getPartnerTypeById ', id);
    console.log('this.allPartnersList ', this.allPartnersList);
    for(let index = 0;index < this.allPartnersList.length;index++){
      if(this.allPartnersList[index].partnerId == id){
        console.log('check ', this.allPartnersList[index]);
        this.productForm.get('partnerType').setValue(this.allPartnersList[index].partnerType);
        this.selectPartner(this.allPartnersList[index].partnerType);
        this.productForm.controls['partnerId'].setValue(this.allPartnersList[index].partnerId);
        break;
      }
    }
  }


  selectCredit(creditapply: any){
    console.log('creditapply ', creditapply);
    this.creditapply = creditapply;
  }

  selectInitalAge(age:any){
    let filteredAges = [];
    this.ageGroup2 = this.ageGroupTemp;
    for(let index = 0; index < this.ageGroup2.length; index++){
      if(age < this.ageGroup2[index].value){
        filteredAges.push(this.ageGroup2[index]);
      }
    }
    this.ageGroup2 = filteredAges;

  }

  selectLastAge(age : any){
    console.log('age limit ', age);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/editsubscription/editsubscription.component.ts